import React, { useEffect, useRef, useState } from 'react';
import './style/ProfilePage.css';
import NavBar from "./component/NavBar";

function ProfilePage() {
    const [profileData, setProfileData] = useState(null);
    const [selectedCarId, setSelectedCarId] = useState(null);

    // состояние для редактирования (только одна строка одновременно)
    const [editingServiceId, setEditingServiceId] = useState(null);
    const [editedService, setEditedService] = useState(null);

    const phone = localStorage.getItem('phoneNumber');
    const nameInputRef = useRef(null);

    useEffect(() => {
        if (!phone) return;

        fetch('http://localhost:8082/api/profile/get-profile-data', {
            method: 'GET',
            headers: {
                'User-Agent': 'insomnia/11.1.0',
                'phone': phone
            }
        })
            .then((res) => {
                if (!res.ok) throw new Error('Ошибка загрузки профиля');
                return res.json();
            })
            .then((data) => {
                setProfileData(data);
                if (data.carEntityList && data.carEntityList.length > 0) {
                    setSelectedCarId(data.carEntityList[0].id);
                }
            })
            .catch(console.error);
    }, [phone]);

    // если пользователь переключил автомобиль — сбрасываем редактирование
    useEffect(() => {
        setEditingServiceId(null);
        setEditedService(null);
    }, [selectedCarId]);

    // фокус на инпут после начала редактирования
    useEffect(() => {
        if (editingServiceId && nameInputRef.current) {
            nameInputRef.current.focus();
            nameInputRef.current.select && nameInputRef.current.select();
        }
    }, [editingServiceId]);

    if (!profileData) return <div>Загрузка...</div>;

    const selectedCar = profileData.carEntityList.find(car => car.id === selectedCarId);

    // начать редактирование — делаем копию service (строки для инпутов)
    const handleEdit = (service) => {
        setEditingServiceId(service.id);
        setEditedService({
            id: service.id,
            service_name: service.service_name != null ? String(service.service_name) : '',
            total_count: service.total_count != null ? String(service.total_count) : '',
            remaining_count: service.remaining_count != null ? String(service.remaining_count) : ''
        });
    };

    // отмена редактирования
    const handleCancel = () => {
        setEditingServiceId(null);
        setEditedService(null);
    };

    // валидация перед отправкой
    const validateEdited = (s) => {
        if (!s) return false;

        if (!s.service_name || String(s.service_name).trim() === '') {
            alert('Введите название сервиса');
            return false;
        }

        if (s.total_count === '' || s.total_count == null || String(s.total_count).trim() === '') {
            alert('Введите количество в поле "Всего"');
            return false;
        }
        const totalNum = Number(s.total_count);
        if (Number.isNaN(totalNum) || !isFinite(totalNum) || totalNum < 0) {
            alert('Введите корректное положительное число в поле "Всего"');
            return false;
        }

        if (s.remaining_count === '' || s.remaining_count == null || String(s.remaining_count).trim() === '') {
            alert('Введите количество в поле "Осталось"');
            return false;
        }
        const remNum = Number(s.remaining_count);
        if (Number.isNaN(remNum) || !isFinite(remNum) || remNum < 0) {
            alert('Введите корректное положительное число в поле "Осталось"');
            return false;
        }

        if (remNum > totalNum) {
            alert('Осталось не может быть больше, чем Всего');
            return false;
        }

        return true;
    };

    // сохранить изменения — отправляем PUT и обновляем локально
    const handleSave = () => {
        if (!editedService) return;

        if (!validateEdited(editedService)) return;

        const payload = {
            ...editedService,
            total_count: Number(editedService.total_count),
            remaining_count: Number(editedService.remaining_count)
        };

        fetch(`http://localhost:8082/api/user-services/integ/${editedService.id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'User-Agent': 'insomnia/11.3.0'
            },
            body: JSON.stringify(payload)
        })
            .then(async (res) => {
                if (!res.ok) {
                    const text = await res.text().catch(() => '');
                    throw new Error(text || 'Ошибка сохранения');
                }
                return res.json();
            })
            .then((updated) => {
                const updatedService = updated && updated.id ? updated : payload;

                setProfileData(prev => {
                    if (!prev) return prev;
                    const newCarList = prev.carEntityList.map(car => {
                        if (car.id !== selectedCarId) return car;
                        const oldData = (car.userServiceEntity && car.userServiceEntity.data) || [];
                        const newData = oldData.map(s => s.id === updatedService.id ? { ...s, ...updatedService } : s);
                        return {
                            ...car,
                            userServiceEntity: {
                                ...(car.userServiceEntity || {}),
                                data: newData
                            }
                        };
                    });
                    return { ...prev, carEntityList: newCarList };
                });

                setEditingServiceId(null);
                setEditedService(null);
            })
            .catch(err => {
                console.error(err);
                alert('Не удалось сохранить: ' + (err.message || err));
            });
    };

    return (
        <div className="about-page">
            <NavBar />
            <div className="profile-container">
                <h2>Личный кабинет</h2>

                {/* авто */}
                <div className="car-buttons">
                    <h3>Выберите автомобиль</h3>
                    {profileData.carEntityList.map((car) => (
                        <button
                            key={car.id}
                            type="button"
                            onClick={() => setSelectedCarId(car.id)}
                            className={car.id === selectedCarId ? 'active' : ''}
                        >
                            {car.brandId?.name} {car.modelId?.name} {car.yearId?.year}
                        </button>
                    ))}
                </div>

                {/* сервисы */}
                {selectedCar && selectedCar.userServiceEntity && selectedCar.userServiceEntity.data && selectedCar.userServiceEntity.data.length > 0 ? (
                    <div className="service-info">
                        <h3>Сервисы по автомобилю</h3>
                        <table className="info-table">
                            <thead>
                            <tr>
                                <th>ID</th>
                                <th>Название сервиса</th>
                                <th>Всего</th>
                                <th>Осталось</th>
                                <th>Действие</th>
                            </tr>
                            </thead>
                            <tbody>
                            {selectedCar.userServiceEntity.data.map((service) => (
                                <tr key={service.id}>
                                    <td>{service.id}</td>

                                    <td>
                                        {editingServiceId === service.id ? (
                                            <input
                                                ref={nameInputRef}
                                                type="text"
                                                value={editedService?.service_name ?? ''}
                                                onChange={(e) =>
                                                    setEditedService(prev => ({ ...prev, service_name: e.target.value }))
                                                }
                                            />
                                        ) : (
                                            service.service_name
                                        )}
                                    </td>

                                    <td>
                                        {editingServiceId === service.id ? (
                                            <input
                                                type="number"
                                                value={editedService?.total_count ?? ''}
                                                onChange={(e) =>
                                                    setEditedService(prev => ({ ...prev, total_count: e.target.value }))
                                                }
                                            />
                                        ) : (
                                            service.total_count
                                        )}
                                    </td>

                                    <td>
                                        {editingServiceId === service.id ? (
                                            <input
                                                type="number"
                                                value={editedService?.remaining_count ?? ''}
                                                onChange={(e) =>
                                                    setEditedService(prev => ({ ...prev, remaining_count: e.target.value }))
                                                }
                                            />
                                        ) : (
                                            service.remaining_count
                                        )}
                                    </td>

                                    <td>
                                        {editingServiceId === service.id ? (
                                            <>
                                                <button type="button" onClick={handleSave}>Сохранить</button>
                                                <button type="button" onClick={handleCancel}>Отмена</button>
                                            </>
                                        ) : (
                                            <button type="button" onClick={() => handleEdit(service)}>Изменить</button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div style={{ marginTop: 20 }}>Сервисы отсутствуют.</div>
                )}
            </div>
        </div>
    );
}

export default ProfilePage;
